import axios from 'axios'
const instance = axios.create({
    // baseURL:'https://loan-longxie-dev.tenserpay.xyz',
    baseURL:'',
    // 跨域携带cookie
    withCredentials:true
})
export default instance



// WEBPACK FOOTER //
// ./src/utils/request.js